// Countryside meadow (Unsplash, free license). Swap for the real photo of the new
// studio's panoramic windows / grass field when it's available (keep this import name).
import heroImg from '../images/hero-meadow.jpg';
import './Hero.css';

export default function Hero() {
  return (
    <section id="sakums" className="hero">
      <img className="hero__img" src={heroImg} alt="Salons Siluets — lauku ainava" />
      <div className="hero__scrim" />

      <div className="container hero__inner">
        <p className="hero__eyebrow">Skaistumkopšana &amp; labsajūta</p>
        <h1 className="hero__title">
          Salons <span>Siluets</span>
        </h1>
        <p className="hero__place">Raunā</p>

        <div className="hero__actions">
          <a href="#masazas" className="btn btn-ghost-light">
            Apskatīt piedāvājumu
          </a>
          <a href="#kontakti" className="hero__link">
            Sazināties →
          </a>
        </div>
      </div>

      <a href="#davanu-karte" className="hero__scroll" aria-label="Ritināt uz leju">
        <span />
      </a>
    </section>
  );
}
